const INITIAL_STATE: any = {
  timeCount: 0,
};

const TimeCountReducer = (state = INITIAL_STATE, action: any): any => {
  switch (action.type) {
    case 'UPDATE_TIMECOUNT':
      return {
        ...state,
        timeCount: action.payload,
      };
    default:
      return state;
  }
};

export default TimeCountReducer;
